module.exports = __webpack_public_path__ + "static/img/10.1a4306c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/10.png
// module id = p2OT
// module chunks = 1